import { Button, Flex, ModalV2 } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";

interface ExitWarningModalProps {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  title?: string;
  message?: string;
}

export const ExitWarningModal = ({
  show,
  onConfirm,
  onCancel,
  confirmLabel = "Confirm",
  title = "Warning",
  message = "Are you sure you want to exit? Any unsaved information will be lost.",
}: ExitWarningModalProps) => (
  <ModalV2
    show={show}
    onHide={onCancel}
    title={title}
    isCentered
    size="small"
    data-testid="exit-warning-modal"
  >
    <ModalV2.Body>{message}</ModalV2.Body>
    <ModalV2.Footer>
      <Flex justifyContent="flex-end" gap={Sizes.SM}>
        <Button data-testid="warning-cancel" variant="neutral" onClick={onCancel}>
          Cancel
        </Button>
        <Button data-testid="warning-confirm" variant="danger" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Flex>
    </ModalV2.Footer>
  </ModalV2>
);
